(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    const initMeltelleRatingFallback = (scope = document) => {
    const detailsBlocks = scope.matches?.('.product-details')
      ? [scope]
      : scope.querySelectorAll?.('.product-details') || [];

    detailsBlocks.forEach((details) => {
      const title = details.querySelector('h1');
      if (!title) return;

      const headerGroup = title.closest('.group-block') || title.parentElement;
      if (!headerGroup) return;

      let fallback = details.querySelector('[data-meltelle-rating-empty]');
      if (!fallback) {
        fallback = document.createElement('div');
        fallback.className = 'meltelle-rating-empty';
        fallback.setAttribute('data-meltelle-rating-empty', '');
        fallback.setAttribute('aria-label', 'No customer reviews yet');
        fallback.innerHTML = '<span class="meltelle-rating-empty__stars" aria-hidden="true">☆☆☆☆☆</span><span>No reviews yet</span>';
        headerGroup.insertAdjacentElement('afterend', fallback);
      }

      const syncFallback = () => {
        const judgeBadge = details.querySelector('.jdgm-prev-badge');
        const reviewCount = Number(judgeBadge?.dataset?.numberOfReviews || 0);
        fallback.hidden = reviewCount > 0;
      };

      syncFallback();

      if (!details.dataset.meltelleRatingObserved) {
        const observer = new MutationObserver(syncFallback);
        observer.observe(details, { childList: true, subtree: true, attributes: true });
        details.dataset.meltelleRatingObserved = 'true';
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initMeltelleRatingFallback());
  document.addEventListener('shopify:section:load', (event) => initMeltelleRatingFallback(event.target));
  } catch(e) { console.error(e); }
})();

})();
